import { render, staticRenderFns } from "./PicRevisionReportView.vue?vue&type=template&id=19cf1fac&"
import script from "./PicRevisionReportView.vue?vue&type=script&lang=js&"
export * from "./PicRevisionReportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports